import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const NO_RETRY = ["/auth/refresh", "/auth/login", "/auth/register"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    if (err.response?.status === 401 && !orig._retry && !NO_RETRY.some((p) => orig.url.includes(p))) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => {
      if (!e || typeof e.msg !== "string") return JSON.stringify(e);
      const field = Array.isArray(e.loc) ? String(e.loc[e.loc.length - 1]).replace(/_/g, " ") : "";
      return field && field !== "body" ? `${field.charAt(0).toUpperCase()}${field.slice(1)}: ${e.msg.replace(/^Value error, /, "")}` : e.msg;
    }).join(" ");
  }
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) =>
  Number(n || 0).toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 });

const toDate = (s) => (/^\d{4}-\d{2}-\d{2}$/.test(s) ? new Date(`${s}T00:00:00`) : new Date(s));

export const openBlob = async (path, filename, download = false) => {
  const win = download ? null : window.open("", "_blank");
  let res;
  try {
    res = await api.get(path, { responseType: "blob" });
  } catch (e) {
    win?.close();
    throw e;
  }
  const url = URL.createObjectURL(res.data);
  if (download || !win) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
  } else {
    win.location.href = url;
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
export const fmtDate = (s) => (s ? toDate(s).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");
